/* NgRx */
import {createAction, props} from '@ngrx/store';
import {
  FetchParticipantInformationModel
} from "../models/fetch-participant-information.model";
import {
  FetchRelationshipQuestionModel
} from "../models/fetch-relationship-question.model";
import {Question} from "../../../../models/question";
import {
  FetchHouseholdQuestionModel
} from "../models/fetch-household-question.model";
import {
  FetchPhiAndPiiQuestionModel
} from "../models/fetch-phi-and-pii-question.model";
import {QuestionList} from "../../../../models/question-list";
import {
  FetchParticipantsListModel
} from "../models/fetch-participants-list.model";
import {Filter} from "../../../../models/filter";
import {ProfileModel} from "../../../../models/profile.model";
import {UpdateRelationModel} from "../models/update-relation.model";
import {SaveAnswersModel} from "../models/save-answers.model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[participants list] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH PARTICIPANTS_LIST ***********/
const FETCH_PARTICIPANTS_LIST_REQUEST = '[participants list] fetch participants list request';
export const FetchParticipantsListRequest = createAction(FETCH_PARTICIPANTS_LIST_REQUEST, props<any>());

const FETCH_PARTICIPANTS_LIST_SUCCESS = '[participants list] fetch participants list success';
export const FetchParticipantsListSuccess = createAction(FETCH_PARTICIPANTS_LIST_SUCCESS, props<{
  participantsList: FetchParticipantsListModel['response']['data'],
  message: string
}>());

const FETCH_PARTICIPANTS_LIST_FAILURE = '[participants list] fetch participants list failure';
export const FetchParticipantsListFailure = createAction(FETCH_PARTICIPANTS_LIST_FAILURE);

/*********** FETCH PARTICIPANT INFORMATION **************/
const FETCH_PARTICIPANT_INFORMATION_REQUEST = '[participants list] fetch participant information requested';
export const FetchParticipantInformationRequest = createAction(FETCH_PARTICIPANT_INFORMATION_REQUEST, props<{
  payload: FetchParticipantInformationModel['request']
}>());

const FETCH_PARTICIPANT_INFORMATION_SUCCESS = '[participants list] fetch participant information successful';
export const FetchParticipantInformationSuccess = createAction(FETCH_PARTICIPANT_INFORMATION_SUCCESS, props<{
  participantInformation: ProfileModel,
  message: string
}>());

const FETCH_PARTICIPANT_INFORMATION_FAILURE = '[participants list] fetch participant information failure';
export const FetchParticipantInformationFailure = createAction(FETCH_PARTICIPANT_INFORMATION_FAILURE, props<{
  message: string
}>());

/*********** FETCH RELATIONSHIP QUESTION **************/
const FETCH_RELATIONSHIP_QUESTION_REQUEST = '[participants list] fetch relationship question requested';
export const FetchRelationshipQuestionRequest = createAction(FETCH_RELATIONSHIP_QUESTION_REQUEST, props<{
  payload: FetchRelationshipQuestionModel['request']
}>());

const FETCH_RELATIONSHIP_QUESTION_SUCCESS = '[participants list] fetch relationship question successful';
export const FetchRelationshipQuestionSuccess = createAction(FETCH_RELATIONSHIP_QUESTION_SUCCESS, props<{
  relationshipQuestion: Question,
  message: string
}>());

const FETCH_RELATIONSHIP_QUESTION_FAILURE = '[participants list] fetch relationship question failure';
export const FetchRelationshipQuestionFailure = createAction(FETCH_RELATIONSHIP_QUESTION_FAILURE, props<{
  message: string
}>());

/*********** FETCH HOUSEHOLD QUESTION **************/
const FETCH_HOUSEHOLD_QUESTION_REQUEST = '[participants list] fetch household question requested';
export const FetchHouseholdQuestionRequest = createAction(FETCH_HOUSEHOLD_QUESTION_REQUEST, props<{
  payload: FetchHouseholdQuestionModel['request']
}>());

const FETCH_HOUSEHOLD_QUESTION_SUCCESS = '[participants list] fetch household question successful';
export const FetchHouseholdQuestionSuccess = createAction(FETCH_HOUSEHOLD_QUESTION_SUCCESS, props<{
  householdQuestion: Question,
  message: string
}>());

const FETCH_HOUSEHOLD_QUESTION_FAILURE = '[participants list] fetch household question failure';
export const FetchHouseholdQuestionFailure = createAction(FETCH_HOUSEHOLD_QUESTION_FAILURE, props<{
  message: string
}>());


/*********** FETCH PHI AND PII QUESTION **************/
const FETCH_PHI_AND_PII_QUESTION_REQUEST = '[participants list] fetch phi and pii question requested';
export const FetchPhiAndPiiQuestionRequest = createAction(FETCH_PHI_AND_PII_QUESTION_REQUEST, props<{
  payload: FetchPhiAndPiiQuestionModel['request']
}>());

const FETCH_PHI_AND_PII_QUESTION_SUCCESS = '[participants list] fetch phi and pii question successful';
export const FetchPhiAndPiiQuestionSuccess = createAction(FETCH_PHI_AND_PII_QUESTION_SUCCESS, props<{
  phiAndPiiQuestionList: QuestionList,
  message: string
}>());

const FETCH_PHI_AND_PII_QUESTION_FAILURE = '[participants list] fetch phi and pii question failure';
export const FetchPhiAndPiiQuestionFailure = createAction(FETCH_PHI_AND_PII_QUESTION_FAILURE, props<{
  message: string
}>());

/*********** FETCH RELATIONS FILTER **************/
const FETCH_RELATIONS_FILTER_REQUEST = '[participants list] fetch relations filter requested';
export const FetchRelationsFilterRequest = createAction(FETCH_RELATIONS_FILTER_REQUEST);

const FETCH_RELATIONS_FILTER_SUCCESS = '[participants list] fetch relations filter successful';
export const FetchRelationsFilterSuccess = createAction(FETCH_RELATIONS_FILTER_SUCCESS, props<{
  relationshipFilter: Filter,
  message: string
}>());

const FETCH_RELATIONS_FILTER_FAILURE = '[participants list] fetch relations filter failure';
export const FetchRelationsFilterFailure = createAction(FETCH_RELATIONS_FILTER_FAILURE, props<{
  message: string
}>());

/******** SET LAR STATUS ***********/
const SET_LAR_STATUS = '[participants list] set lar status';
export const SetLarStatus = createAction(SET_LAR_STATUS, props<{ isLar: boolean }>());

/*********** SAVE ANSWERS **************/
const SAVE_ANSWERS_REQUEST = '[participants list] save answers requested';
export const SaveAnswersRequest = createAction(SAVE_ANSWERS_REQUEST, props<{ payload: SaveAnswersModel['request'], fromPhiPiiDetailsScreen?: boolean, callback?: (success: boolean) => void }>());

const SAVE_ANSWERS_SUCCESS = '[participants list] save answers successful';
export const SaveAnswersSuccess = createAction(SAVE_ANSWERS_SUCCESS, props<any>());

const SAVE_ANSWERS_FAILURE = '[participants list] save answers failure';
export const SaveAnswersFailure = createAction(SAVE_ANSWERS_FAILURE);

/*********** UPDATE RELATION **************/
const UPDATE_RELATION_REQUEST = '[participants list] update relation requested';
export const UpdateRelationRequest = createAction(UPDATE_RELATION_REQUEST, props<{
  payload: UpdateRelationModel['request'], callback?: (success: boolean) => void
}>());

const UPDATE_RELATION_SUCCESS = '[participants list] update relation successful';
export const UpdateRelationSuccess = createAction(UPDATE_RELATION_SUCCESS, props<{
  message: string
}>());

const UPDATE_RELATION_FAILURE = '[participants list] update relation failure';
export const UpdateRelationFailure = createAction(UPDATE_RELATION_FAILURE);

/*********** MARK HIPAA CONSENT **************/
const MARK_HIPAA_CONSENT_REQUEST = '[participants list] mark hipaa consent requested';
export const MarkHipaaConsentRequest = createAction(MARK_HIPAA_CONSENT_REQUEST, props<any>());

const MARK_HIPAA_CONSENT_SUCCESS = '[participants list] mark hipaa consent successful';
export const MarkHipaaConsentSuccess = createAction(MARK_HIPAA_CONSENT_SUCCESS, props<{
  message: string
}>());

const MARK_HIPAA_CONSENT_FAILURE = '[participants list] mark hipaa consent failure';
export const MarkHipaaConsentFailure = createAction(MARK_HIPAA_CONSENT_FAILURE, props<{
  message: string
}>());

/******** EDIT PROFILE ***********/
const EDIT_PROFILE_REQUEST = '[participants list] edit profile requested';
export const EditProfileRequest = createAction(EDIT_PROFILE_REQUEST, props<any>());

const EDIT_PROFILE_SUCCESS = '[participants list] edit profile successful';
export const EditProfileSuccess = createAction(EDIT_PROFILE_SUCCESS, props<any>());

const EDIT_PROFILE_FAILURE = '[participants list] edit profile failure';
export const EditProfileFailure = createAction(EDIT_PROFILE_FAILURE);
